module.exports = __webpack_public_path__ + "media/check-kiosks.aea35cc4.mp4";